module.exports = __webpack_public_path__ + "img/17.3a13215a.jpg";